var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"empty-layout"}},[_c('v-app',{attrs:{"id":"empty-app"}},[_c('v-main',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_vm._t("default")],2)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }